import React from 'react'
import i18next from 'i18next'
import { Box } from '@node-space/storybook-components/dist/Box'
import { DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { DepositDetails } from 'types/transaction'

interface FiatDepositProps {
  depositDetails: DepositDetails
  amountWithCurrency: string
  transactionReference: string
  transactionDate: string
}

const FiatDeposit = ({
  depositDetails,
  amountWithCurrency,
  transactionReference,
  transactionDate,
}: FiatDepositProps) => {
  return (
    <>
      <DataListItem
        id="amount-with-currency"
        testId="amount-with-currency"
        title={i18next.t('transactions.sideBar.paymentInAmountReceived')}
        body={amountWithCurrency}
      />
      {!!transactionReference && (
        <DataListItem
          id="transaction-reference"
          testId="transaction-reference"
          title={i18next.t('transactions.sideBar.reference')}
          body={ellipseMiddleText(transactionReference, 20, 10)}
          copyText={transactionReference}
        />
      )}
      <DataListItem
        id="transaction-date"
        testId="transaction-date"
        title={i18next.t('date')}
        body={transactionDate}
      />
      <p className="text-h4 text-foreground-prominent mt-3">{i18next.t('senderDetails')}</p>
      <Box gapY={8}>
        {!!depositDetails?.senderAccountNumber && (
          <DataListItem
            id="sender-account-number"
            testId="sender-account-number"
            title={i18next.t('walletsPage.fromBankAccountNo')}
            body={depositDetails?.senderAccountNumber}
          />
        )}
        {depositDetails?.senderBankCode && (
          <DataListItem
            id="sender-bank-code"
            testId="sender-bank-code"
            title={i18next.t('walletsPage.fromBankCode')}
            body={depositDetails?.senderBankCode}
          />
        )}
        {depositDetails?.senderName && (
          <DataListItem
            id="sender-name"
            testId="sender-name"
            title={i18next.t('walletsPage.receivedFrom')}
            body={depositDetails?.senderName}
          />
        )}
      </Box>
    </>
  )
}

export default FiatDeposit
